import React from 'react';
import { Box, Divider } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

const ERHoldingSectionSkeleton = () => (
  <Box px={2} py={3.37}>
    <Box
      mb={3}
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Skeleton
        variant="rectangular"
        width={70}
        height={70}
        sx={{ marginRight: '16px' }}
      />
      <Divider orientation="vertical" flexItem />
      <Skeleton
        variant="rectangular"
        width={70}
        height={70}
        sx={{ marginLeft: '16px' }}
      />
    </Box>
    <Box
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <Skeleton variant="text" width="70%" height={40} />
    </Box>
  </Box>
);
export { ERHoldingSectionSkeleton };
